
import "./LeftNav.css"

const LeftNav = () => {
  // Updated categories to match the IDs in RegularMenu.jsx
  const categories = [
    // { id: "chicken-burgers", name: "Chicken Burgers" },
    // { id: "beef-burgers", name: "Beef Burgers" },
    { id: "wings-and-tenders", name: "Chicken Wings & Tenders" },
    { id: "corn-dogs", name: "Corn Dogs" },
    { id: "meal-deals", name: "Meal Deals" },
    { id: "curries", name: "Curries" },
    { id: "wok-fire-build-your-box", name: "WOK & FIRE Build Your Box" },
    { id: "sides", name: "Sides" },
    { id: "drinks", name: "Drinks" },
    { id: "milkshakes", name: "Milkshakes" },
  ]

  const handleCategoryClick = (id) => {
    const element = document.getElementById(id)
    if (element) {
      // Scroll to the element, aligning its top with the top of the scrollable area
      element.scrollIntoView({ behavior: "smooth", block: "start" })
    }
  }

  return (
    <nav className="left-nav" aria-label="Menu Navigation">
      <div className="left-nav-header">
        <div className="header-decoration"></div>
        <h2 className="left-nav-title">Menu Categories</h2>
        <div className="header-decoration"></div>
      </div>
      <div className="left-nav-content">
        <ul className="left-nav-list">
          {categories.map((category, index) => (
            <li key={category.id} className="left-nav-item" style={{ animationDelay: `${index * 30}ms` }}>
              <button
                className="left-nav-link"
                onClick={() => handleCategoryClick(category.id)}
                aria-label={`Navigate to ${category.name} section`}
              >
                <span className="button-content">
                  <span className="button-text">{category.name.toUpperCase()}</span>
                  <span className="button-arrow">›</span>
                </span>
                <div className="button-glow"></div>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  )
}

export default LeftNav
